import React from 'react';

import styled from 'styled-components';

import Radio from 'components/lib/Radio';
import { ReviewAlertPreference } from 'types/communities';

import CommunityReviewAlertModeSettings from './CommunityReviewAlertModeSettings';
import { CommunityReviewAlertScope, ReviewAlertFilterField } from './constants';
import { CommunityReviewAlertScopeSettings } from './types';

const Description = styled.div`
  margin-top: 20px;
  font-size: 14px;
`;

type StatusOption = {
  label: string;
  value: number;
};

type StatusElements = {
  ON: StatusOption;
  OFF: StatusOption;
};

type AlertFlags = Record<CommunityReviewAlertScope, boolean>;

type Props = {
  activeTab: CommunityReviewAlertScope;
  alertFlags: AlertFlags;
  activeTabSettings: CommunityReviewAlertScopeSettings;
  statusElements: StatusElements;
  onActiveTabStatusChange: (nextStatus: number) => void;
  onAlertModeChange: (mode: number) => void;
  onOverallFilterChange: (
    field: ReviewAlertFilterField,
    value: ReviewAlertPreference[ReviewAlertFilterField]
  ) => void;
  onCategoryToggle: (reviewCategoryId: number, checked: boolean) => void;
  onCategoryFilterChange: (
    reviewCategoryId: number,
    field: ReviewAlertFilterField,
    value: ReviewAlertPreference[ReviewAlertFilterField]
  ) => void;
};

const CommunityReviewAlertsTabContent = ({
  activeTab,
  alertFlags,
  activeTabSettings,
  statusElements,
  onActiveTabStatusChange,
  onAlertModeChange,
  onOverallFilterChange,
  onCategoryToggle,
  onCategoryFilterChange,
}: Props) => {
  const activeTabDescription =
    activeTab === CommunityReviewAlertScope.COMMUNITY
      ? "Configure alert rules for this community's reviews."
      : "Configure alert rules for this community's competitors.";

  return (
    <>
      <Description>{activeTabDescription}</Description>

      <Radio.Group
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 15,
        }}
        value={alertFlags[activeTab] ? statusElements.ON.value : statusElements.OFF.value}
        onChange={(event: any) => onActiveTabStatusChange(event.target.value)}
      >
        {Object.values(statusElements)
          .sort((a, b) => Number(a.value) - Number(b.value))
          .map((status) => (
            <Radio className={'large'} key={status.value} value={status.value}>
              {status.label}
            </Radio>
          ))}
      </Radio.Group>
      {alertFlags[activeTab] && (
        <CommunityReviewAlertModeSettings
          settings={activeTabSettings}
          onAlertModeChange={onAlertModeChange}
          onOverallFilterChange={onOverallFilterChange}
          onCategoryToggle={onCategoryToggle}
          onCategoryFilterChange={onCategoryFilterChange}
        />
      )}
    </>
  );
};

export default CommunityReviewAlertsTabContent;
